var exports = {
  "ss": "PrivacySetupModal.module__current___cmwwZ1",
  "Gf": "PrivacySetupModal.module__sectionTitle___cmwwZ1",
  "$D": "PrivacySetupModal.module__currentText___cmwwZ1",
  "mt": "PrivacySetupModal.module__overrides___cmwwZ1",
  "aM": "PrivacySetupModal.module__overridesTitle___cmwwZ1",
  "OW": "PrivacySetupModal.module__guildList___cmwwZ1",
  "RZ": "PrivacySetupModal.module__guildItem___cmwwZ1",
  "J5": "PrivacySetupModal.module__guildName___cmwwZ1",
  "Ro": "PrivacySetupModal.module__guildState___cmwwZ1",
  "fS": "PrivacySetupModal.module__optionName___cmwwZ1",
  "uZ": "PrivacySetupModal.module__currentTag___cmwwZ1",
  "Bb": "PrivacySetupModal.module__apply___cmwwZ1",
  "dr": "PrivacySetupModal.module__applyLabel___cmwwZ1",
  "z": "PrivacySetupModal.module__summary___cmwwZ1",
};

module.exports = exports;
